module.exports = __webpack_public_path__ + "static/media/layerWhite.bb1ebaac.svg";